module.exports = __webpack_public_path__ + "media/images/clients/coins-45d3c38c069b10687d85e478ded6c0bd.svg";